export function datadogLog(
  type: 'info' | 'error' | 'debug' | 'warn',
  msg: string,
  data
) {
  if (typeof window.DD_LOGS !== 'undefined' && window.DD_LOGS.logger) {
    if (type === 'info') {
      window.DD_LOGS.logger.info(msg, data);
    }
    if (type === 'error') {
      window.DD_LOGS.logger.error(msg, data);
    }
    if (type === 'debug') {
      window.DD_LOGS.logger.debug(msg, data);
    }
    if (type === 'warn') {
      window.DD_LOGS.logger.warn(msg, data);
    }
  }
}
